<section class="w3l-form-25">
  <div class="w3l-form-25">
    <BR>
 </div>
 <div class="form-inner-cont">
  <div class="w3l-form-25">
      <h1>{{'Accounting Reports Data' | translate }}</h1>
      <h1 style="color: rgb(79, 79, 161);font-weight: bolder;">{{ wk_Title | translate }}</h1>
  </div>
</div>

<div id="w3l-appointment">
  <div class="wrapper">
  <div class="d-grid doctor-appointment">
    <form action="#" method="post" >
      <form [hidden]="HiedBank">
          <div class="appointment-form-field">
            <label style="width: 150px;">{{ 'Bank/Treasury' | translate }}</label>
            <select id="kind" name="trbank" style="width: 550px;;background-color:  rgb(187, 203, 238);" [(ngModel)]= "trbank" [value]="trbank" required>
              <option value="{{cls.bnkcode}}" *ngFor="let cls of bankList; let i = index">{{cls.bnkname}}</option>
            </select>
          </div>
        </form>
        <form [hidden]="HiedPatirnt">
          <div class="appointment-form-field">
            <label style="width: 150px;">{{wk_Patient_Customer}}</label>
            <input type="text" name="pacode"  required="" style="width: 100px;" [(ngModel)]="trcln_supp" (change)="RetrivePatient()" >
            <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialogPatient()"></span>
            <label id="w3l-appointment" class="appointment-form-field" style="width: 400px;background-color:  rgb(187, 203, 238);border-style: solid;border-width: .5px;border-color: slategray;">{{trcln_supp_Name}}</label>
          </div>
        </form>
        <form [hidden]="HidItem">
          <div class="appointment-form-field">
            <label style="width: 150px;">{{ 'Item' | translate }}</label>
            <input type="text" name="pacode"  required="" style="width: 100px;" [(ngModel)]="detitem" (change)="RetriveItems()" >
            <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialogItem()"></span>
            <label id="w3l-appointment" class="appointment-form-field" style="width: 400px;background-color:  rgb(187, 203, 238);border-style: solid;border-width: .5px;border-color: slategray;">{{detitemname}}</label>
          </div>
        </form>
        <form [hidden]="HidSupplier">
          <BR>
            <div class="appointment-form-field" >
              <label style="width: 150px;" >{{ 'Supplier' | translate }}</label>
              <span class="fa fa-search"  style="cursor: grab;" (click)="openDialogSupplier()"></span>
              <input type="text" name="expSupplier" maxlength="50ch"  placeholder="" required="" style="width: 150px;" [(ngModel)]="trcln_supp" (change)="retrivesupplier()">
              <label id="w3l-appointment" class="appointment-form-field" style="width: 350px;background-color:  rgb(187, 203, 238);border-style: solid;border-width: .5px;border-color: slategray;">{{trcln_supp_Name}}</label>

            </div>
         </form>
         <form [hidden]="HidRevenue">
         <div class="appointment-form-field">
          <label style="width: 150px;">{{ 'Revenue Type' | translate }}</label>
          <select id="kind" name="revenue" style="width: 550px;;background-color:  rgb(187, 203, 238);" [(ngModel)]= "trclass" [value]="trclass" required>
            <option value="{{cls.revcode}}" *ngFor="let cls of revenueList; let i = index">{{cls.revname}}</option>
        </select>
      </div>
         </form>
         <form [hidden]="HidExpenses">
          <div class="appointment-form-field">
            <label style="width: 150px;">{{ 'Expenses Type' | translate }}</label>
            <select id="kind" name="trexpensses" style="width: 550px;;background-color:  rgb(187, 203, 238);" [(ngModel)]= "trclass" [value]="trclass" required>
              <option value="{{cls.expcode}}" *ngFor="let cls of expenssesList; let i = index">{{cls.expname}}</option>
          </select>
          </div>
        </form>
        <form [hidden]="HidHospital">
          <div class="appointment-form-field">
            <label style="width: 150px;">{{ 'Hospital' | translate }}</label>
            <select id="kind" name="trhospital" style="width: 550px;;background-color:  rgb(187, 203, 238);" [(ngModel)]= "trhospital" [value]="trhospital" required>
              <option value="{{cls.hoscode}}" *ngFor="let cls of hospitalList; let i = index">{{cls.hosname}}</option>


          </select>
        </div>
        </form>
        <form [hidden]="HidDoctor">
          <div class="appointment-form-field">
            <label style="width: 150px;">{{ 'Doctor' | translate }}</label>
            <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialogDoctor()"></span>
            <input type="text" name="expdoctor" placeholder="" required="" style="width: 150px;" [(ngModel)]="trdoctor" (change)="retrivedoctors()">
            <input type="text" name="expdoctorname" disabled="true" required="" style="width: 352px; "   [(ngModel)]="trdoctor_Name">
             </div>
        </form>
        <form [hidden]="HidOption" >
          <div style="width: 50%;font-size: large;font-weight: bold;text-align: center;">
            <BR>
            <label style="width: 20px;" ></label>
            <input type="radio" name="DStatus" style="width: 20%;font-size: large;font-weight: bold;" value="D" checked [(ngModel)]="Wk_Option" >{{'Detailed' | translate}}
            <label style="width: 60px;" ></label>
          </div>
        </form>
        <form [hidden]="HidOption">
          <div style="width: 50%;font-size: large;font-weight: bold;text-align: center;">
            <label style="width: 20px;" ></label>
            <input type="radio" name="DStatus" style="width: 20%;font-size: large;font-weight: bold;" value="T"  [(ngModel)]="Wk_Option" >{{'Total' | translate}}
            <label style="width: 60px;" ></label>
          </div>
        </form>
        <BR>
        <form [hidden]="HiedDate">
              <div class="appointment-form-field" [hidden]="HiedDate">
                <label style="width: 150px;">{{ 'From Date' | translate }}</label>
                <input type="date" name="revname" style="width: 200px;" [(ngModel)]="FromDate" >
                <label style="width: 50px;"></label>
                <label style="width: 100px;">{{ 'To Date' | translate }}</label>
                <input type="date" name="revname" style="width: 200px;" [(ngModel)]="ToDate" >
              </div>
        </form>
        <form [hidden]="HidStore">
          <BR>
          <div class="appointment-form-field">
            <label style="width: 150px;">{{ 'Store' | translate }}</label>
            <select id="trstore" name="trsstor" class="example-label" style="width: 550px;background-color:  rgb(187, 203, 238);" [(ngModel)]="hedstore"  >
              <option *ngFor="let cur of storesList" value="{{cur.strcode}}" >{{cur.strdesc1}}</option>
            </select>
          </div>
        </form>
        <form [hidden]="HidClass">
          <BR>
          <div class="appointment-form-field">
            <label style="width: 150px;">{{ 'Class.' | translate }}</label>

            <select id="classification" name="classification" required="" style="width: 550px;background-color:  rgb(187, 203, 238);" [(ngModel)]="itClass" [value]="itClass">
              <option value="{{cls.clasCode}}" *ngFor="let cls of classificationList; let i = index">{{cls.clasName}}</option>
             </select>
          </div>
        </form>
        <form [hidden]="HidPrice">
          <BR>
          <div class="appointment-form-field">
            <label style="width: 150px;">نوع  القائمة</label>

            <select id="classification" name="classification" required="" style="width: 550px;background-color:  rgb(187, 203, 238);" [(ngModel)]="PriceType" [value]="PriceType">
              <option value="1">حسب سعر التكلفة</option>
              <option value="2">حسب سعر البيــع</option>
              <option value="3">إذن صرف فـــارغ</option>
             </select>
          </div>
        </form>

    </form>
  </div>
  </div>
</div>
<BR>
<BR>

  <BR>
  <form style="width: 100%;text-align: center;">
    <label style="width: 25%;"></label>
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px; font-weight: bold;" name="print" (click)="Print()">{{ 'Print' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px;font-weight: bold;" name="Delete" (click)="Exit()">{{ 'Home' | translate }}</button>

  </form>
  <BR>
    <BR>

</section>


